import colours from 'theme/atoms/colours';

const SCALE_ROUNDING = 20;

function hexToRgb(hex: string): [number, number, number] {
  const value = hex.replace('#', '');
  return [
    parseInt(value.slice(0, 2), 16),
    parseInt(value.slice(2, 4), 16),
    parseInt(value.slice(4, 6), 16),
  ];
}

function toHex(channel: number): string {
  return Math.round(channel).toString(16).padStart(2, '0');
}

function mix(from: string, to: string, ratio: number): string {
  const [fromRed, fromGreen, fromBlue] = hexToRgb(from);
  const [toRed, toGreen, toBlue] = hexToRgb(to);
  const channel = (start: number, end: number) => start + (end - start) * ratio;
  return `#${toHex(channel(fromRed, toRed))}${toHex(
    channel(fromGreen, toGreen)
  )}${toHex(channel(fromBlue, toBlue))}`;
}

const SCALE_STOPS = [
  colours.shade[0],
  colours.warning[100],
  colours.warning[400],
  colours.error[500],
  mix(colours.error[500], colours.primary[500], 0.5),
];

export function getHeatColour(ratio: number): string {
  const clamped = Math.min(Math.max(ratio, 0), 1);
  const segments = SCALE_STOPS.length - 1;
  const position = clamped * segments;
  const index = Math.min(Math.floor(position), segments - 1);
  return mix(SCALE_STOPS[index], SCALE_STOPS[index + 1], position - index);
}

export function buildHeatGradient(direction: 'to top' | 'to right'): string {
  const stops = SCALE_STOPS.map(
    (colour, index) =>
      `${colour} ${Math.round((index / (SCALE_STOPS.length - 1)) * 100)}%`
  );
  return `linear-gradient(${direction}, ${stops.join(', ')})`;
}

export function getHeatScaleMax(maxCount: number): number {
  if (maxCount <= 0) return SCALE_ROUNDING;
  return Math.ceil(maxCount / SCALE_ROUNDING) * SCALE_ROUNDING;
}

export default getHeatColour;
